import { createReducer } from '@reduxjs/toolkit'

import { loggedInClubOne, loggedOutClubOne, receivedClubOneDetails } from '../actions/actions'

const initialState = { clubOneLevel: 'NONE' }

const user = createReducer(initialState, {
  [loggedInClubOne]: (state, action) => ({ ...state, ...action.payload }),
  [loggedOutClubOne]: () => initialState,
  [receivedClubOneDetails]: (state, action) => ({ ...state, ...action.payload })
})

export default user
